import { useMutation, useQueryClient } from '@tanstack/react-query';

import useApi from '@/hooks/useApi/useApi';

export function useMarkNotificationAsRead() {
  const { axiosInstance } = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (notificationId: number | string) => {
      const { data } = await axiosInstance.post<{ success: boolean }>(
        `/api/v1/notifications/${notificationId}/mark_as_read`
      );
      return data;
    },
    onSuccess: () => {
      // Invalidate notifications query to refresh the list
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
    },
  });
}
